module.exports = __webpack_public_path__ + "img/002-excel.f73bf970.svg";